import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { recruitmentCompanyService } from '../../services/recruitmentCompanyService';
import { authService } from '../../services/authService';
import RecruitmentCompanyNav from '../../components/RecruitmentCompanyNav';
import RecruitmentCompanyBottomNavigation from '../../components/RecruitmentCompanyBottomNavigation';
import Loader from '../../components/Loader';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const RecruitmentCompanyPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subscribingPlanId, setSubscribingPlanId] = useState(null);
  const user = authService.getCurrentUser();
  const navigate = useNavigate();
  const { t, locale } = useTranslation();

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const data = await recruitmentCompanyService.getPlans();
      // Laravel Resource collection returns { data: [...] }
      setPlans(Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []));
    } catch (error) {
      console.error('Error loading plans:', error);
      const message = error?.response?.data?.message || error?.message || 'Failed to load plans';
      toast.error(message);
      setPlans([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const handleSubscribe = async (planId) => {
    try {
      setSubscribingPlanId(planId);
      await recruitmentCompanyService.subscribe(planId);
      toast.success(t('company.plans.subscribeSuccess') || 'تم الاشتراك بنجاح');
      navigate('/recruitment-company/subscriptions');
    } catch (error) {
      const message = error?.response?.data?.message || t('company.plans.subscribeFailed') || 'فشل الاشتراك';
      toast.error(message);
    } finally {
      setSubscribingPlanId(null);
    }
  };

  if (loading) {
    return <Loader fullScreen={true} size="large" />;
  }

  return (
    <div className="employee-home-page" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      <RecruitmentCompanyNav user={user} />

      {/* Header */}
      <div className="px-3 mb-4 mt-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="section-title mb-1">{t('company.plans.subtitle') || 'باقات الاشتراك'}</h3>
            <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>{t('company.plans.subtitleDescription') || 'اختر الباقة المناسبة لشركتك'}</p>
          </div>
        </div>
      </div>

      {/* Plans */}
      <div className="all-jobs-section px-3 mb-5">
        {(!plans || plans.length === 0) ? (
          <div className="text-center py-5">
            <p className="empty-state-text mb-3">{t('company.plans.noPlansAvailable') || 'لا توجد باقات متاحة حالياً'}</p>
          </div>
        ) : (
          <div className="jobs-list">
            {plans.map((plan) => (
              <div key={plan.id} className="job-card mb-3">
                <div className="d-flex align-items-start gap-3">
                  <div className="company-logo-card">
                    <div className="company-logo-text text-dark align-content-center">
                      <b>{plan?.name?.charAt(0)?.toUpperCase() || 'P'}</b>
                    </div>
                  </div>
                  <div className="job-content flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="flex-grow-1">
                        <div className="job-title-card mb-1">
                          {plan.name || t('company.plans.planName') || 'الباقة'}
                        </div>
                        <div className="job-company-location mb-2">
                          {typeof plan.price === 'number' ? `${plan.price.toFixed(2)} $` : (plan.price ?? '—')}
                        </div>
                        <div className="job-tags d-flex gap-2 mb-2 flex-wrap">
                          {'duration_days' in plan && (
                            <span className="status-badge-success">{t('company.plans.duration') || 'المدة'}: {plan.duration_days} {t('company.plans.durationDays') || 'يوم'}</span>
                          )}
                          <br />
                          {'vacancies_limit' in plan && (
                            <span className="status-badge-info">{t('company.plans.vacanciesLimit') || 'عدد الوظائف'}: {plan.vacancies_limit ?? (t('company.plans.unlimited') || 'غير محدود')}</span>
                          )}
                         
                        </div>
                        {plan.description && (
                          <div
                            className="text-muted"
                            style={{ fontSize: '0.9rem' }}
                            dangerouslySetInnerHTML={{ __html: plan.description }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="d-flex gap-2 flex-wrap">
                      <button
                        onClick={() => handleSubscribe(plan.id)}
                        className="btn-apply"
                        style={{
                          background: 'linear-gradient(135deg, #608fd3 0%, #4a7bc4 100%)',
                          color: 'white'
                        }}
                        disabled={!!subscribingPlanId}
                      >
                        {subscribingPlanId === plan.id ? (t('company.plans.subscribing') || 'جارٍ الاشتراك...') : (t('company.plans.subscribeNow') || 'اشترك الآن')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <RecruitmentCompanyBottomNavigation />
    </div>
  );
};

export default RecruitmentCompanyPlans;

